import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { GESTURE_IS_CLOSING_CLASS } from './modal-gesture.constants';

const MODAL_WINDOW_SELECTOR = 'ms-modal-window';
const MODAL_BODY_SELECTOR = '.modal-body';
const MODAL_BACKDROP_SELECTOR = 'ms-modal-backdrop';
const EVENT_DETAILS_MODAL_SELECTOR = '.event-details-modal';
const BACKGROUND_SLOT_HEADER_SELECTOR = '.slot-header';
const BACKGROUND_MAIN_COLUMN_SELECTOR = 'ms-main-column';
const OVERLAY_CONTAINER_SELECTOR = '.cdk-overlay-container';
const BETSLIP_BAR_SELECTOR = '.betslip-bar__bar';

@Injectable({ providedIn: 'root' })
export class ModalGestureQueriesService {
    #overlayContainer: HTMLElement | null;

    readonly #document = inject(DOCUMENT);

    private get overlayContainer(): HTMLElement | null {
        return (this.#overlayContainer ??= this.#document.querySelector<HTMLElement>(OVERLAY_CONTAINER_SELECTOR));
    }

    /** Currently querying dom elements directly rather than using service state (e.g. openedModalsStorageService)
     * due to a possible race with service state not being set yet when opening - may be a temporary solution */
    getActiveModalWindowsExcludingCurrent(): HTMLElement[] {
        const modalWindowsExcludingCurrent = this.getModalWindows().slice(0, -1);

        return modalWindowsExcludingCurrent.filter((modal) => !modal.classList.contains(GESTURE_IS_CLOSING_CLASS));
    }

    getModalWindows(): HTMLElement[] {
        return Array.from(this.overlayContainer?.querySelectorAll<HTMLElement>(MODAL_WINDOW_SELECTOR) ?? []);
    }

    getModalWindow(): HTMLElement | null | undefined {
        const modals = this.getModalWindows();

        return modals[modals.length - 1];
    }

    getModalBody(): HTMLElement | null {
        return this.overlayContainer?.querySelector<HTMLElement>(MODAL_BODY_SELECTOR) ?? null;
    }

    getModalBackdrop(): HTMLElement | null | undefined {
        const backdrops = this.getModalBackdrops();

        return backdrops[backdrops.length - 1];
    }

    getModalBackdrops(): HTMLElement[] {
        return Array.from(this.overlayContainer?.querySelectorAll<HTMLElement>(MODAL_BACKDROP_SELECTOR) ?? []);
    }

    getEventDetailsModalBackdrop(): HTMLElement | null {
        return this.getEventDetailsModal()?.parentElement?.querySelector<HTMLElement>(MODAL_BACKDROP_SELECTOR) ?? null;
    }

    getEventDetailsModal(): HTMLElement | null {
        return this.overlayContainer?.querySelector<HTMLElement>(EVENT_DETAILS_MODAL_SELECTOR) ?? null;
    }

    getBackgroundSlotHeader(): HTMLElement | null {
        return this.#document.querySelector<HTMLElement>(BACKGROUND_SLOT_HEADER_SELECTOR);
    }

    getBackgroundMainColumn(): HTMLElement | null {
        return this.#document.querySelector<HTMLElement>(BACKGROUND_MAIN_COLUMN_SELECTOR);
    }

    getBetslipBar(): HTMLElement | null {
        return this.#document.querySelector<HTMLElement>(BETSLIP_BAR_SELECTOR);
    }
}
